import { Text } from "@jsq/ds/core";
import { DocumentRefreshStatusEnum } from "~/graphql/supergraphEnums";
import { gridCellStyles } from "~/pages/Compliance/Common/GridCellBackgrounds/styles_vanilla.css";
import { formatCountText } from "~/utils/strings";
import {
  baseContainer,
  countText,
  warningIcon,
  darkIcon,
  warningText,
  darkText,
  greenText,
  lightIcon,
} from "./styles_vanilla.css";
import { StatusConfig, DocumentRefreshCellRendererProps } from "./types";

export const DOCUMENT_STATUS_CONFIG: Partial<Record<DocumentRefreshStatusEnum, StatusConfig>> =
  {
    [DocumentRefreshStatusEnum.Expired]: {
      containerClass: `${baseContainer} ${gridCellStyles.warning}`,
      icon: {
        type: "exclamation-triangle",
        className: warningIcon,
        variant: "outline",
      },
      text: {
        content: "Expired",
        className: warningText,
      },
    },
    [DocumentRefreshStatusEnum.ExpiringSoon]: {
      containerClass: `${baseContainer} ${gridCellStyles.warning}`,
      icon: {
        type: "calendar-clock",
        className: warningIcon,
        variant: "outline",
      },
      text: {
        content: "Expiring soon",
        className: warningText,
      },
    },
    [DocumentRefreshStatusEnum.RequestSent]: {
      containerClass: `${baseContainer} ${gridCellStyles.default}`,
      icon: {
        type: "envelope-circle-check",
        className: darkIcon,
        variant: "outline",
      },
      text: {
        content: {
          type: "dynamic",
          render: (data?: DocumentRefreshCellRendererProps["data"]) => {
            const sentCount = data?.documentRefreshTooltipData?.requestSentCount ?? 0;
            if (sentCount > 1) {
              return (
                <>
                  Request sent{" "}
                  <Text asSpan className={countText}>
                    {formatCountText(sentCount, "time")}
                  </Text>
                </>
              );
            }
            return "Request sent";
          },
        },
        className: darkText,
      },
    },
    [DocumentRefreshStatusEnum.RequestSentOverdue]: {
      containerClass: `${baseContainer} ${gridCellStyles.warning}`,
      icon: {
        type: "envelope-circle-check",
        className: warningIcon,
        variant: "outline",
      },
      text: {
        content: {
          type: "dynamic",
          render: (data?: DocumentRefreshCellRendererProps["data"]) => {
            const sentCount = data?.documentRefreshTooltipData?.requestSentCount ?? 0;
            if (sentCount > 1) {
              return (
                <>
                  Request sent (overdue){" "}
                  <Text asSpan className={countText}>
                    {formatCountText(sentCount, "time")}
                  </Text>
                </>
              );
            }
            return "Request sent (overdue)";
          },
        },
        className: warningText,
      },
    },
    [DocumentRefreshStatusEnum.Active]: {
      containerClass: `${baseContainer} ${gridCellStyles.default}`,
      icon: {
        type: "check",
        className: lightIcon,
      },
      text: {
        content: "No action required",
        className: greenText,
      },
    },
    [DocumentRefreshStatusEnum.NoDocuments]: {
      containerClass: `${baseContainer} ${gridCellStyles.default}`,
      text: {
        content: "No documents",
        className: darkText,
      },
    },
    [DocumentRefreshStatusEnum.NoExpiryDate]: {
      containerClass: `${baseContainer} ${gridCellStyles.default}`,
      icon: {
        type: "calendar-xmark",
        className: darkIcon,
        variant: "outline",
      },
      text: {
        content: "No expiry date",
        className: darkText,
      },
    },
  };
